<button type="button" class="{{to.buttonClass}}" (click)="onClick()" [ngClass]="{ disabled: to.disabled }">
  <span *ngIf="iconClass"> <i [ngClass]="iconClass"></i> </span>
  {{to.label}}
</button>